import NunitoRegular from './Nunito/Nunito-Regular.ttf'
import MontserratBold from './Montserrat/Montserrat-Bold.ttf'
import NunitoBold from './Nunito/Nunito-Bold.ttf'
import RobotoMonoRegular from './RobotoMono/RobotoMono-Regular.ttf'

const fonts = { NunitoRegular, MontserratBold, NunitoBold, RobotoMonoRegular }

export default fonts
